import SettingGroups from "./setting-groups";

export default SettingGroups;
